/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/hozoor',
  name: 'Hozoor',
  component: () => import('@/views/hozoor/Index'),
}]
